<template>
  <div class="select_dialog_embed" :style="{top: scrollHeight + 'px', left: scrollLeft + 'px'}">
    <div class="data_download_embed_msg">
      <div class="select_dialog_embed_box"
           :class="{'select_dialog_embed_box_508' : showType === 'resetOrderTime' || showType === 'resetInventory' || showType === 'resetGoods' || showType === 'resetSales'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--单笔订单下载/按创建时间进行订单下载/单笔售后单下载/按创建时间进行下载售后单/平台链接商品下载加在状态-->
          <div v-if="showType === 'oneOrder' || showType === 'orderCreateTime'
                || showType === 'oneSales' || showType === 'salesCreateTime' || showType === 'linkGoodsID'"
               class="select_dialog_embed_box_loading">
            <img src="../../../assets/img/pic_loading.gif" alt="加载中">
            <span>操作正在进行中，请勿关闭浏览器或页面........</span>
          </div>

          <!--重置下载时间/重置同步时间-->
          <div v-if="showType === 'resetTime'"
               class="select_dialog_embed_box_handle"  style="width: 100%">
            <div class="ml15" style="margin-bottom: 40px">
              请确定是否要重置{{type}}时间，重置后数据将从新的时间开始进行{{type}}！
            </div>
          </div>

          <!--停用-->
          <div v-if="showType === 'disable'"
               class="select_dialog_embed_box_handle" style="width: 95%; text-align: center">
            <div style="margin-bottom: 40px">
              请确定是否要停用当前{{type}}，停用后当前{{type}}将停止运行！
            </div>
          </div>

          <!--启用-->
          <div v-if="showType === 'enable'"
               class="select_dialog_embed_box_handle" style="width: 95%; text-align: center">
            <div style="margin-bottom: 40px">
              请确定是否要启用当前{{type}}，启用后当前{{type}}将开始运行！
            </div>
          </div>
        </div>

        <!--只有在下载的时候才会弹出的错误提示框-->
        <!--弹出框底部-->
        <div v-if="showType !== 'oneOrder' || showType !== 'orderCreateTime'
                || showType !== 'oneSales' || showType !== 'salesCreateTime' || showType !== 'linkGoodsID'"
             class="select_dialog_embed_box_bottom">
          <button class="btn_normal" @click="submitBtn()">提交</button>
          <button class="btn_cancel" @click="cancelBtn(false)">取消</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
    </div>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'data-download-embed-msg',
    /**
     *  title：  头部名
     *  enable=启用  disable=停用
     *  showType: oneOrder=单笔订单下载  orderCreateTime=按创建时间进行订单下载
     *  oneSales=单笔售后单下载  salesCreateTime=按创建时间进行下载售后单  linkGoodsID=平台链接商品下载
     *  resetOrderTime=重置订单下载时间  resetInventory=重置库存同步时间  resetGoods=重置商品下载时间  resetSales=重置售后单下载时间
     *  enableOrder=订单下载启用  disableOrder=订单下载停用
     *  enableInventory=库存同步启用  disableInventory=库存同步停用
     *  enableGoods=商品下载启用  disableGoods=商品下载停用
     *  enableSales=售后单下载启用  disableSales=售后单下载停用
     *  orderMsg:  订单信息
     * */
    props: ['title', 'showType', 'orderMsg', 'shopId', 'scrollLeft', 'scrollHeight'],
    components: {MsgDialog, LoadingDialog},
    data () {
      return {
        type: '', // 下载还是同步类型
        isLoading: false, // 加载框的显示
        loadingType: 'NOP', // 加载框显示的类型： NOP=普通加载框   options=操作加载框
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 重置时间
    /*  changeShopAsynTimeById(type, time) {
        this.isMsg = true;
        this.$axios.post(this.Global.changeShopAsynTimeById(this.shopId, type, new Date(time).toISOString()), null, this.Header).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      }, */

      // 根据店铺Id、类型Id修改时间节点、频率
      changeShopAsynTimeById() {
        this.isLoading = true;
        this.loadingType = 'options';
        this.$axios.post(this.Global.changeShopAsynTimeById(this.shopId, this.orderMsg.DockingTypeId, new Date(this.orderMsg.LastTime).toISOString(), this.orderMsg.PingRate), null).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res.data) {
              if (!res.data.errorMsg.length) {
                // window.open(res.data.resData, '_blank');
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '操作成功';
                // self.cancelBtn(true);
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 根据店铺Id、类型Id更改同步控制是否停用
      changeShopStatusById() {
        let typeStatus = 0;
        if (this.showType === 'enable') {
          typeStatus = 0;
        } else if (this.showType === 'disable') {
          typeStatus = 1;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        this.$axios.post(this.Global.changeShopStatusById(this.shopId, this.orderMsg.DockingTypeId, typeStatus), null).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res.data) {
              if (!res.data.errorMsg.length) {
                // window.open(res.data.resData, '_blank');
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '操作成功';
                // self.cancelBtn(true);
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

    /*  // 修改启停用状态
      changeShopStatusById(type, typeStatus) {
        this.$axios.post(this.Global.changeShopStatusById(this.shopId, type, typeStatus), null, this.Header).then((res) => {
          console.log(res);
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      }, */

      // 提交按钮
      submitBtn() {
        // this.cancelBtn(null);
        if (this.showType === 'resetTime') {
          this.changeShopAsynTimeById();
        } else if (this.showType === 'enable' || this.showType === 'disable') {
          this.changeShopStatusById();
        }
        /*  if (this.showType === 'enableOrder' || this.showType === 'disableOrder') {
          this.changeShopStatusById(1, this.orderMsg);
        } else if (this.showType === 'resetInventory') {
          this.changeShopAsynTimeById(2, this.orderMsg);
        } else if (this.showType === 'enableInventory' || this.showType === 'disableInventory') {
          this.changeShopStatusById();
        } else if (this.showType === 'resetGoods') {
          this.changeShopAsynTimeById(3, this.orderMsg);
        } else if (this.showType === 'enableGoods' || this.showType === 'disableGoods') {
          this.changeShopStatusById(3, this.orderMsg);
        } else if (this.showType === 'resetSales') {
          this.changeShopAsynTimeById(4, this.orderMsg);
        } else if (this.showType === 'enableSales' || this.showType === 'disableSales') {
          this.changeShopStatusById(4, this.orderMsg);
        } */
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, msg: this.orderMsg, handleType: type});
      },

      // 关闭这个页面
      closeTipMsgDialog() {
        this.cancelBtn(false);
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc) {
          this.cancelBtn(true);
        }
      }
    },
    created() {
      if (this.showType === 'resetOrderTime' || this.showType === 'enableOrder' || this.showType === 'disableOrder') {
        this.type = '下载';
      } else if (this.showType === 'resetInventory' || this.showType === 'enableInventory' || this.showType === 'disableInventory') {
        this.type = '同步';
      } else if (this.showType === 'resetGoods' || this.showType === 'enableGoods' || this.showType === 'disableGoods') {
        this.type = '下载';
      } else if (this.showType === 'resetSales' || this.showType === 'enableSales' || this.showType === 'disableSales') {
        this.type = '下载';
      }

      if (this.showType === 'enable' || this.showType === 'disable' || this.showType === 'resetTime') {
        if (this.orderMsg.DockingTypeId === 4) {
          this.type = '同步';
        } else {
          this.type = '下载';
        }
      }
      // this.isMsg = true;
      // 计时器
      /* let time = 3;
       const self = this;
       const timer = setInterval(function () {
         console.log(time);
         time = --time;
         if (time < 1) {
           self.isMsg = true;
           self.txtMsg = '这里是加载错误的信息';
           clearInterval(timer);
         }
       }, 1000); */
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .data_download_embed_msg {
    .select_dialog_embed_box {
      &.select_dialog_embed_box_508 {
        width: 508px;
        min-width: 508px;

        .select_dialog_embed_box_handle {
          text-align: center;
        }
      }

      .select_dialog_embed_box_content {
        .select_dialog_embed_box_loading {
          overflow: hidden;

          img {
            float: left;
            margin-left: -25px;
          }

          span {
            display: inline-block;
            height: 130px;
            line-height: 130px;
            float: left;
            margin-left: -50px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/data-download-embed-msg.vue